<template>
  <div>
    <!-- <Card1></Card1> -->
    <base-card
      :listTitle="this.listTitle"
      :listContent="this.listContent"
      :listUrl="this.listUrl"
    ></base-card>
    <base-box :key="this.reRenderKey" :article="this.article"></base-box>
  </div>
</template>

<script>
import BaseCard from "../components/BaseCard.vue";
import BaseBox from "../components/BaseBox.vue";
import getPath from "../utils/getPath";
import getArticleList from "../utils/getArticleList";

export default {
  components: {
    BaseCard,
    BaseBox
  },
  data() {
    return {
      article: {},
      listTitle: "",
      listContent: {},
      listUrl: "",
      isRender: false,
      reRenderKey: 0
    };
  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        getPath(this.$http, newVal, "/huayin/show-edit-article/").then(res => {
          this.article.title = res.data.data[0].title;
          this.article.content = res.data.data[0].content;
          this.forceRerender();
        });
      },
      deep: true,
      immediate: true
    }
  },
  async created() {
    getArticleList(this.$http, "/huayin/get-articles", "", "", "1", "8").then(
      articleList => {
        console.log(articleList.data.data);
        this.listContent = articleList.data.data;
        this.listTitle = "更多内容";
        this.listUrl = "/#/introduction/";
      }
    );
  },
  methods: {
    forceRerender() {
      this.reRenderKey += 1;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/introduction.vue